import React, {Fragment} from 'react'
import Config from '../launch/config'

import './css/artifacts-info.css'

const ArtifactsInfo = () => {
    const collectedArtifacts = Object.keys(Config.artifacts).filter(
        (key) => Config.artifacts[key].isCollected
    ).length

    return (
        <Fragment>
            <div className="artifacts-info__preview">
                <img
                    alt="artifact"
                    className="artifacts-info__preview-img"
                    src={`${process.env.PUBLIC_URL}/img/artifact.png`}
                />
            </div>
            <div className="artifacts-info__description">
                <h1 className="modal-heading">Artifacts</h1>
                <p>
                    These mysterious objects of unknown origin are scattered
                    across the star system. Bring an artifact into orbit of a
                    colonized planet to collect it.
                </p>
                {Config.artifacts && (
                    <p>
                        {collectedArtifacts} out of{' '}
                        {Object.keys(Config.artifacts).length} artifacts have
                        been collected.
                    </p>
                )}
            </div>
        </Fragment>
    )
}

export default ArtifactsInfo
